module.exports = __webpack_public_path__ + "img/rebate-bonus.f3eed2bb.png";